import { Injectable } from '@angular/core';
import { pipelines } from 'media-stream-library';
 
@Injectable({ providedIn: 'root' })
export class AxisRtspPlayerService {
  private pipeline?: any;
 
  /**
   * Startet Playback über RTSP-over-WebSocket → MSE.
   * @param videoEl <video>-Element
   * @param wsUri   WebSocket-Endpoint deines Backends/Kamera, z. B.:
   *                ws://localhost:4000/camera/rtsp-over-websocket?rs=<GUID>&token=<JWT>
   * @param rtspUri RTSP-URL zur Kamera, z. B.:
   *                rtsp://axis/axis-media/media.amp?videocodec=h264&recordingid=<ID>
   */
  start(videoEl: HTMLVideoElement, wsUri: string, rtspUri: string) {
    this.stop();
 
    // MSL-Pipeline erstellen
    this.pipeline = new pipelines.Html5VideoPipeline({
      ws:   { uri: wsUri },    // RTSP ↔ WS Signalisierung/Tunnel
      rtsp: { uri: rtspUri },  // Ziel-RTSP (inkl. Parametern wie recordingid)
      mediaElement: videoEl,   // MSE-Sink
    });
 
    // PLAY absetzen
    this.pipeline.rtsp.play();
  }
 
  /**
   * Optional: PLAY mit Range-Header (Axis-Aufnahmen per Zeitfenster).
   * Übergib z. B. range = "clock=20250911T075923Z-" oder "npt=0-".
   * Achtung: das genaue API-Shape kann je nach MSL-Version leicht variieren.
   */
  playWithRange(range: string) {
    if (!this.pipeline) return;
    // Gängige MSL-Versionen akzeptieren ein Options-Objekt mit range:
    try {
      this.pipeline.rtsp.play({ range });
    } catch {
      // Fallback: manche Versionen nutzen ein Header-Objekt
      try { this.pipeline.rtsp.play(undefined, { Range: range }); } catch {}
    }
  }
 
  stop() {
    if (!this.pipeline) return;
    try { this.pipeline.close?.(); } catch {}
    this.pipeline = undefined;
  }
}